import React, { useEffect, useState } from 'react'
import FeedComponent from 'src/components/Feed/FeedComponent'
import cookie from 'cookie'
import GET_CURRENT_USER from 'src/graphql/queries/getCurrentUser'
import { API } from 'src/config/API/api.config'
import { ApolloClient, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { createUploadLink } from 'apollo-upload-client'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'src/store/store'
import { fetchProductRecommendation } from 'src/store/slices/fetchAllFeedSlice'

const NewFeedPage: React.VFC = () => {
  // const [scrollY, setScrollY] = useState(0)

  // useEffect(() => {
  //   window.addEventListener('scroll', () => {
  //     setScrollY(window.pageYOffset)
  //   })
  // }, [scrollY])
  // const dispatch = useAppDispatch()

  // const productRecommendations = useSelector((state: any) => state?.feedData?.productRecommendations)
  // const fetchProduct = (product_id = null, type = null) => {
  //   let update_product = productRecommendations?.product?.getAllProducts?.data?.map((prd) => {
  //     if (prd?.id === product_id) {
  //       return {
  //         ...prd,
  //         likes: type === 'like' ? { id: 3.3333 } : null,
  //         like_count: type === 'like' ? (parseInt(prd.like_count) || 0) + 1 : (parseInt(prd.like_count) || 1) - 1,
  //       }
  //     } else {
  //       return prd
  //     }
  //   })
  //   if (update_product) {
  //     dispatch(fetchProductRecommendation(update_product))
  //   }
  // }

  // const fetchUpdatedProduct = (product_id, type) => {
  //   fetchProduct(product_id, type)
  // }

  return (
    <React.Fragment>
      <FeedComponent postData={{}} />
      {/* <Modal
        title=""
        open={showStoryModal}
        wrapClassName="highlight-modal-align"
        className="my-auto rounded-2xl"
        onOk={hideStoryModalHandler}
        onCancel={hideStoryModalHandler}
        footer={null}
        closable={false}
        width={432}
      >
        <HighLightModal />
      </Modal> */}
    </React.Fragment>
  )
}

export default NewFeedPage

// export async function getServerSideProps(context) {
//   const httpLink = createUploadLink({
//     uri: API.endpoint,
//   })
//   const { req } = context
//   const cookies = cookie.parse(req?.headers?.cookie || '')
//   const token = cookies?.token

//   const authLink = setContext((_, { headers }) => {
//     return {
//       headers: {
//         ...headers,
//         Authorization: token ? `Bearer ${token}` : '',
//       },
//     }
//   })

//   const client1 = new ApolloClient({
//     link: authLink.concat(httpLink),
//     cache: new InMemoryCache(),
//   })

//   if (!token) {
//     return {
//       redirect: {
//         destination: '/',
//         permanent: false,
//       },
//     }
//   }

//   const {
//     data: { currentUser },
//   } = await client1.query({
//     query: GET_CURRENT_USER,
//     fetchPolicy: 'network-only',
//   })

//   try {
//     if (currentUser?.user?.isFirstTime) {
//       return {
//         redirect: {
//           destination: '/onboarding',
//           permanent: false,
//         },
//       }
//     }
//     return {
//       props: {
//         feed: {},
//       },
//     }
//   } catch (error) {
//     console.error('Error fetching data:', error)
//     return {
//       redirect: {
//         destination: '/',
//         permanent: false,
//       },
//     }
//   }
// }
